export enum GeoJsonFeatureTypes {
    Feature = 'Feature',
    Unknown = '',
}

export enum GeoJsonTypes {
    FeatureCollection = 'FeatureCollection',
    Unknown = '',
}

export enum MapStylesFillOpacity {
    Default = 0.6,
    Selected = 0.8,
}

export enum MapStylesStrokeWeight {
    Default = 1,
    Selected = 8,
}

export enum MapStylesStrokeColor {
    Default = '#FFFFFF', // white,
    Selected = '#FFFFFF', // white
}

export enum MapStylesZIndex {
    Default = -1,
    Selected = 1,
}

export enum GeographyTypes {
    MarketArea = 'MKT',
    ExtendedMarketArea = 'X_MKT',
    State = 'STATE',
    Region = 'REGION',
    ThreeDigitZip = 'THREEDZ',
    Country = 'COUNTRY',
    Unknown = '',
}

export enum Directions {
    In = 'IN',
    Out = 'OUT',
    Unknown = '',
}

export enum TimeTypes {
    ThirtyDaysBack = '30_DAYS_BACK',
    EightDaysBack = '8_DAYS_BACK',
    PreviousBusinessDay = 'PREV_BUSINESS_DAY',
    Current = 'Current',
    Forecast = 'FORECAST',
    Unknown = '',
}

export enum EquipmentTypes {
    Flatbed = 'FLATBED',
    Van = 'VAN',
    Reefer = 'REEFER',
    Unknown = '',
}

export enum CapacityLevels {
    VeryLoose = 'Very Loose',
    ModeratelyLoose = 'Moderately Loose',
    SlightlyLoose = 'Slightly Loose',
    Neutral = 'Neutral Market',
    SlightlyTight = 'Slightly Tight',
    ModeratelyTight = 'Moderately Tight',
    VeryTight = 'Very Tight',
    NoData = 'Not Available',
    NoArea = 'Select an area on the map or enter a location to see information.',
    CurrentlyUnavailable = 'Currently Unavailable',
    Empty = '',
}

export enum GeoJsonGeometryTypes {
    Polygon = 'Polygon',
    MultiPolygon = 'MultiPolygon',
    Unknown = 'Unknown',
}
